var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sceTextField',{ref:"input",attrs:{"value":_vm.value,"name":_vm.name,"label":'customField.' + _vm.config.label},on:{"input":function($event){return _vm.updateInput($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }